import React, { useEffect, useState } from "react";
import { api, fmtINR } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function Commission() {
  const [procs, setProcs] = useState([]);
  useEffect(() => { api.get("/procedures").then((r) => setProcs(r.data)); }, []);

  const totalCommission = procs.reduce((s, p) => s + (p.commission_amount || 0), 0);
  const totalCompanyProfit = procs.reduce((s, p) => s + (p.company_profit || 0), 0);
  const avgMargin = procs.length ? (procs.reduce((s, p) => s + (p.net_margin || 0), 0) / procs.length).toFixed(1) : 0;

  return (
    <div className="space-y-6" data-testid="commission-page">
      <div><h2 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">Commission</h2><p className="text-slate-500 mt-1">Commission & margin overview across procedures</p></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="p-6 rounded-xl border-slate-200 dark:border-slate-800 shadow-sm"><div className="text-xs uppercase tracking-[0.15em] font-semibold text-slate-400">Total Commission Payout</div><div className="font-heading text-2xl font-extrabold mt-1 text-blue-600">{fmtINR(totalCommission)}</div></Card>
        <Card className="p-6 rounded-xl border-slate-200 dark:border-slate-800 shadow-sm"><div className="text-xs uppercase tracking-[0.15em] font-semibold text-slate-400">Total Company Profit</div><div className="font-heading text-2xl font-extrabold mt-1 text-emerald-600">{fmtINR(totalCompanyProfit)}</div></Card>
        <Card className="p-6 rounded-xl border-slate-200 dark:border-slate-800 shadow-sm"><div className="text-xs uppercase tracking-[0.15em] font-semibold text-slate-400">Average Net Margin</div><div className="font-heading text-2xl font-extrabold mt-1">{avgMargin}%</div></Card>
      </div>
      <Card className="rounded-xl border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow className="bg-slate-50 dark:bg-slate-800/50 hover:bg-slate-50">
              <TableHead>Procedure</TableHead><TableHead>Category</TableHead><TableHead className="text-right">Avg Price</TableHead>
              <TableHead className="text-right">Comm %</TableHead><TableHead className="text-right">Comm Amt</TableHead>
              <TableHead className="text-right">Company Profit</TableHead><TableHead className="text-right">Net Margin</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {procs.map((p) => (
                <TableRow key={p.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/40">
                  <TableCell className="font-medium">{p.name}</TableCell>
                  <TableCell className="text-sm text-slate-500">{p.category}</TableCell>
                  <TableCell className="text-right tabular-nums">{fmtINR(p.avg_price)}</TableCell>
                  <TableCell className="text-right">{p.commission_pct}%</TableCell>
                  <TableCell className="text-right tabular-nums">{fmtINR(p.commission_amount)}</TableCell>
                  <TableCell className="text-right tabular-nums text-emerald-600">{fmtINR(p.company_profit)}</TableCell>
                  <TableCell className="text-right"><Badge variant="outline" className={p.net_margin < 20 ? "border-red-200 text-red-600 bg-red-50" : "border-emerald-200 text-emerald-700 bg-emerald-50"}>{p.net_margin}%</Badge></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
